<template>
  <div class="wrapper">
    <div class="ndc-app-white-line"></div>
    <div class="ndc-app-blue-line"></div>
    <div class="active-tab" :style="topComputed"></div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {
    name: 'SpacerNdcAppTabsLayoutLeft',
    computed: {
      ...mapState('ndcApp', ['app']),
      tabs() {
        return this.app.screen.reports.tabList;
      },
      topComputed() {
        let topStyle = '';
        if (Number.isInteger(this.tabs.active)) {
          topStyle = `${this.tabs.active * 38 + 80}px`;
        } else if (Number.isInteger(this.tabs.subactive)) {
          topStyle = `${this.tabs.subactive * 38 + 422}px`;
        }
        return {
          top: topStyle,
        };
      },
    },
  };
</script>
<style lang="less" scoped>
  .wrapper {
    position: relative;
    flex: 0 0 100%;
    background: #f3f3f4;

    .common {
      position: absolute;
      width: 100%;
      height: 34px;
    }

    .ndc-app-white-line {
      .common();
      height: 46px;
      background-color: #fff;
    }

    .ndc-app-blue-line {
      .common();
      background-color: #0d71b9;
      top: 46px;
    }

    .active-tab {
      position: absolute;
      display: block;
      width: 100%;
      height: 38px;
      background: #fff;
      top: 80px;
    }
  }
</style>